import jQuery from "jquery";
window.$ = jQuery;
import Swiper from "swiper/bundle";

// Import only collapse
import "bootstrap/js/dist/collapse.js";
import "bootstrap/js/dist/modal.js";

import "./menu-header";
import "./menu-footer";

import "./tirefindercomponent";
import { TireFinderModal } from "./tirefindercomponent";
import "./flyout";

import "./cookie";

import "./unsubscribeform";

document.addEventListener("DOMContentLoaded", function () {
    // Initialize the application
    this.url = $(".find-tire[data-url]").data("url");
    $(".find-tire").Flyout(
        {
            id: "tirefinder",
            changeIds: false,
            zindex: 2000,
            content: {
                type: "url",
                copyType: "append",
                src: wpApiSettings.root + "goodyearforward/v1/" + this.url,
            },
            position: [
                { breakpoint: "sm", position: "left", size: "362" },
                { breakpoint: "md", position: "left", size: "660" },
                { breakpoint: "lg", position: "top", size: "580" },
                { breakpoint: "xl", position: "top", size: "535" },
            ],
            destroyOnClose: true,
            onComplete: (flyout, contentElement, trigger) => {
                try {
                    console.log("find-tire");
                    new TireFinderModal(flyout, contentElement, trigger);
                } catch (error) {
                    console.log(error);
                }
            },
        },
        ".find-tire"
    );
});

$(function () {
    // Collapsible content
    ["xs", "sm", "md", "lg", "xl"].forEach(function (e) {
        let t = ".collapsible-" + e + " .title";
        $("body").on("click", t, function (t) {
            t.preventDefault();
            $(this)
                .parents(".collapsible-" + e)
                .toggleClass("active");
            $(this)
                .parents(".collapsible-" + e)
                .hasClass("active")
                ? $(this).attr("aria-expanded", !0)
                : $(this).attr("aria-expanded", !1);
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    let swiper = new Swiper(".swiper-hero-carousel", {
        slidesPerView: 1,
        spaceBetween: 1,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
            hide: false,
        },
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const carouselElements = document.querySelectorAll(".swiper-carousel");
    if (!carouselElements) return;

    carouselElements.forEach((carouselElement) => {
        const defaultOptions = {
            loop: false,
            scrollbar: true,
            slidesPerView: "3",
            spaceBetween: -40,
            slidesPerViewTablet: "3",
            spaceBetweenTablet: -40,
            slidesPerViewDesktop: "3",
            spaceBetweenDesktop: -60,
            centeredSlides: false,
            slidesOffsetBefore: 0,
        };
        let carouselOptions = JSON.parse(carouselElement.getAttribute("data-carousel-options") || "{}");
        carouselOptions = { ...defaultOptions, ...carouselOptions };
        const isAutoCarousel = $(carouselElement).data("carousel-type");

        const swiperConfig = {
            direction: "horizontal",
            loop: carouselOptions.loop,
            slidesPerView: isAutoCarousel ? "auto" : carouselOptions.slidesPerView,
            spaceBetween: carouselOptions.spaceBetween,
            centeredSlides: carouselOptions.centeredSlides,
            a11y: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            slidesOffsetBefore: carouselOptions.slidesOffsetBefore,
            breakpoints: {
                768: {
                    slidesPerView: isAutoCarousel ? "auto" : carouselOptions.slidesPerViewTablet,
                    spaceBetween: carouselOptions.spaceBetweenTablet,
                    slidesOffsetBefore: carouselOptions.slidesOffsetBeforeTablet ?? carouselOptions.slidesOffsetBefore,
                },
                1024: {
                    slidesPerView: isAutoCarousel ? "auto" : carouselOptions.slidesPerViewDesktop,
                    spaceBetween: carouselOptions.spaceBetweenDesktop,
                    slidesOffsetBefore: carouselOptions.slidesOffsetBeforeDesktop ?? carouselOptions.slidesOffsetBefore,
                },
            },
            keyboard: {
                enabled: true,
            },
        };

        if (carouselOptions.scrollbar) {
            swiperConfig.scrollbar = {
                el: ".swiper-scrollbar",
                draggable: true,
            };
        } else {
            swiperConfig.pagination = {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
            };
        }

        const swiper = new Swiper(carouselElement, swiperConfig);

        $(carouselElement)
            .find(".swiper-button-prev")
            .on("keydown", function (e) {
                if (e.key === "Enter") {
                    e.preventDefault();
                    swiper.slideToLoop(0);
                }
            });

        $(carouselElement)
            .find(".swiper-button-next")
            .on("keydown", function (e) {
                if (e.key === "Enter") {
                    e.preventDefault();
                    swiper.slideToLoop(swiper.slides.length - 1);
                }
            });

        swiper.on("slideChangeTransitionEnd", function () {
            swiper.update();
        });
    });
});

$(function () {
    $(".unsubscribe-form-modal-trigger").on("click", function (e) {
        e.preventDefault();
        $("#unsubscribe_form_modal").modal();
    });

    if (window.location.hash === "#unsubscribe-form") {
        $("#unsubscribe_form_modal").modal("show");
    }

    $("#unsubscribe_form_modal").on("hide.bs.modal", function (event) {
        console.log("--unsubscribe form modal hidden--");
        if (window.location.hash === "#unsubscribe-form") {
            history.replaceState(null, "", window.location.pathname + window.location.search);
        }
    });
    $("#unsubscribe_form_modal").on("show.bs.modal", function () {
        console.log("--unsubscribe form modal shown--");
        if (window.location.hash != "#unsubscribe-form") {
            history.pushState(null, null, "#unsubscribe-form");
        }
    });
});
